import { Button, Checkbox, DatePicker, Form, Input, Select, Table, message } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { useSelector } from "react-redux";
import LogUserItem from "./log-user-item";
import { getLogUserResult } from "../../extensions/helper";
import "./logs.css";
import { tableRenderDateTime } from "../../extensions/table-render";
import { RefreshButton } from "../../extensions/design";
import { BtnSettingsTable, tblGetColumns } from "../../controls/table-settings.js/table-settings";

const tableName = "logs";

const Logs = () => {
    const user = useSelector((s) => s.user);
    const [filter,setFilter] = useState({
        begPer: dayjs(),
        endPer: dayjs().add(1, 'day'),
        searchStr: "",
        filter: 0
    })
    const [items, setItems] = useState([]);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [vids, setVids] = useState([]);
    const [item, setItem] = useState();
    const [objectVids, setObjectVids] = useState([]);
    const [allCompanies, setAllCompanies] = useState(false);
    const [tableKey, setTableKey] = useState(0);

    useEffect(() => {
        serverFetch("loguser/vids")
            .then(data => setVids(data))
            .catch(e => console.log(e.message));
        serverFetch("loguser/objectvids")
            .then(data => setObjectVids(data))
            .catch(e => console.log(e.message));
    }, [])

    const getData = () => {
        form.setFieldsValue(filter);
        setLoading(true);
        let url = `LogUser?begPer=${filter.begPer.format('YYYY-MM-DD')}&endPer=${filter.endPer.format('YYYY-MM-DD')}&SearchStr=${filter.searchStr}`;
        if (allCompanies) {
            url += '&allCompanies=true';
        }
        serverFetch(url, 
            { method: 'GET' }, user
        )
            .then((data) => {
                setItems(data);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                e.UserMessage && message.error(e.UserMessage);
            });
    }

    useEffect(getData, [filter, form, user, allCompanies]);

    const getLogUserVidName = (value) => {
        const vid = vids && vids.find(i => i.id === value);
        return vid ? vid.name : `[${value}]`
    }

    const getLogUserVidObjectName = (value) => {
        const vid = objectVids && objectVids.find(i => i.id === value);
        return vid ? vid.name : `[${value}]`
    }

    const baseColumns = [
        { title: '#', dataIndex: 'id', width: "1em", align: 'center' },
        { title: 'Дата', dataIndex: 'createdOn', width: "1em", align: 'center', render: tableRenderDateTime },
        { title: 'Вид', dataIndex: 'vid', width: "1em", align: 'left', render: (_,record) => getLogUserVidName(record.vid) },
        { title: 'Клиент', dataIndex: 'clientName', width: "1em", align: 'left' },
        { title: 'Телефон', dataIndex: 'clientPhone', width: "1em", align: 'left' },
        { title: 'Компания', dataIndex: 'companyName', width: "1em", align: 'left' },
        { title: 'Пользователь', dataIndex: 'userName', width: "1em", align: 'left' },
        { title: 'Комментарий', dataIndex: 'comment', width: "1em", align: 'left' },
        { title: 'Результат', dataIndex: 'result', width: "1em", align: 'center', render: (value) => getLogUserResult(value) },
        { title: 'Объект', dataIndex: 'objectVid', width: "1em", align: 'left', render: (_,record) => getLogUserVidObjectName(record.objectVid)  },
        { title: 'Объект #', dataIndex: 'objectId', width: "1em", align: 'left' },
    ];

    const columns = tblGetColumns(baseColumns, tableName);

    const onCloseItem = () => setItem();
    // Поиск по SearchStr делает API (#, объект #, клиент, телефон, комментарий);
    // на клиенте остаётся только фильтр по виду.
    const filteredItems = items && items.filter((item) => !filter.vid || filter.vid === item.vid);
    const vidOptions = vids.map(i => ({label: `[${i.id}] ${i.name}`, value: i.id}))

    const onValuesChange = value =>  setFilter({ ...filter, ...value }); 
    const onTableSettingsChange = () => setTableKey(prev => prev + 1);
    
    return<div className="sport-form-content logs-container">
        <div className="sport-form-title">
            <div>Период с</div>
            <DatePicker format="DD.MM.YYYY" allowClear={false} value={filter.begPer} onChange={e => onValuesChange({begPer: e})}/>
            <div>по</div>
            <DatePicker format="DD.MM.YYYY" allowClear={false} value={filter.endPer} onChange={e => onValuesChange({endPer: e})}/>
            <Select options={vidOptions} style={{width: 400}} allowClear value={filter.vid} onChange={e => onValuesChange({vid: e})}/>
            <Input
                className="logs-search"
                placeholder="Поиск: #, объект #, клиент, телефон, комментарий"
                value={filter.searchStr}
                onChange={e => onValuesChange({searchStr: e.target.value})}
            />
            {user.isSuperadmin && (
                <Checkbox checked={allCompanies} onChange={e => setAllCompanies(e.target.checked)}>
                    По всем компаниям
                </Checkbox>
            )}
            <RefreshButton onClick={getData} />
            <BtnSettingsTable name={tableName} columns={baseColumns} onSettingsChange={onTableSettingsChange}/>
        </div>
        <Table 
            key={tableKey}
            dataSource={filteredItems} 
            columns={columns} 
            pagination={false}
            rowKey="id"
            onRow={(record) => {return {onClick: () => {setItem(record)}}} }
            size="small"
        />
        {item && <LogUserItem id={item.id} onClose={onCloseItem} />}
    </div>
}

export default Logs;